import { motion, useScroll, useSpring } from "framer-motion";

/*
 * Thin gold reading-progress bar pinned to the top of the page.
 * Transform-only, so it never triggers layout during scroll.
 */
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      aria-hidden
      style={{ scaleX }}
      className="fixed top-0 left-0 right-0 h-[2px] bg-primary origin-left rtl:origin-right z-[60]"
    />
  );
}
